<template>

	<div class="c-form-duplicate">
		<h6 class="c-text-icon margin-t-24 margin-b-16">
			Artikel
			<svg @click="deleteItem" class="c-form-duplicate__delete color-gray-600 margin-l-8" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M9 11c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm6 0c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1Zm3 8c0 .551-.448 1-1 1H7c-.552 0-1-.449-1-1V8h12v11ZM10 4.328c0-.155.214-.328.5-.328h3c.286 0 .5.173.5.328V6h-4V4.328ZM21 6h-5V4.328C16 3.044 14.879 2 13.5 2h-3C9.121 2 8 3.044 8 4.328V6H3c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V8h1c.55 0 1-.45 1-1s-.45-1-1-1Z" id="trash"/></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#trash"/></svg>
		</h6>

		<div v-if="edit">
			<div class="c-form-element c-form-element--horizontal no-margin-b">
				<div class="c-form-element__label no-margin-t">
					<label>Artikelnaam</label>
				</div>	
				<div class="c-form-element__container c-form-element__container--text margin-b-8">
					{{product.name}}
				</div>
			</div>
		</div>

		<div v-else>
			<c-select
				:horizontal="true"
				:label="'Artikel'"
				:options="items"
				:required="true"
				v-model="product_id"
				name="product_id"
				DisplayName="name,article_number"
				:ValueName="'id'"
				:displaySeperator="true">
			</c-select>
		</div>

		<c-input 
			:label="'Aantal'"
			:horizontal="true"
			class="c-form-element--medium"
			type="number" 
			:name="'expected' + $.uid"
			v-model="expected"
			required />

		<p class="bulk-error" v-if="amount && bulk && amount < expected">Let op er zijn nog maar {{ amount }} artikelen op voorraad</p>

		<p class="bulk-error" v-if="bulk && available_bulk_items > 0">Let op er zijn reeds {{available_bulk_items}} in bestelling </p>


	</div>

</template>

<script>
import Form from '@mixins/Form';

export default {
	mixins: [Form],
	data() {
		return {
			product_id: '',
			expected: '',
			available_bulk_items: '',
		}
	},
	props: {
		items: {
			required: true
		},
		product: {
			required: false
		},
		edit: {
			default: false
		},
		bulk: {
			default: false
		}
	},
	emits: ['delete-item'],
	computed: {
		amount() {
			if (Array.isArray(this.items) && this.product_id) {
				const item = this.items.find(s => s.id == this.product_id);
				return item ? item.available_items : '';
			}
			return '';
		}
	},
	watch: {
		product_id() {
			if(this.bulk){
				this.$xhr.get('/api/getavailableitems/' + this.product_id).then( ( {result}) => {
						this.available_bulk_items = result;
					}).catch( (e) => {
				});
			}
		}
	},
	methods: {
		deleteItem () {
			this.$emit('delete-item', this.product_id);
		},
		getData() {

			let asns_data;
			if(this.edit){
				asns_data = {
				product_id: this.product_id,
				expected: this.expected,
				arrived: this.arrived,
				};
			}
			else {
				asns_data = {
					product_id: this.product_id,
					expected: this.expected,
				};
			}
			
			return asns_data;
		},
		clear()
		{
			this.product_id = '';
			this.expected = '';
		}
	},
	mounted(){

		if(this.bulk && this.edit){
			this.product_id = this.product.id;
			this.expected = this.product.expected;
		}
		else if(this.edit){
			this.product_id = this.product.id;
			this.expected = this.product.quantity.expected ?? this.product.expected;
			this.arrived = this.product.quantity.arrived;
		}
	}
}
</script>